'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactSlidedown = require('react-slidedown');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _FundCarbonFootprint = require('./FundCarbonFootprint.css');

var _FundCarbonFootprint2 = _interopRequireDefault(_FundCarbonFootprint);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundCarbonFootprint = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise cient navigate blocked until page loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(_FundCarbonFootprint2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundCarbonFootprint, _Component);

  function FundCarbonFootprint(props) {
    (0, _classCallCheck3.default)(this, FundCarbonFootprint);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundCarbonFootprint.__proto__ || (0, _getPrototypeOf2.default)(FundCarbonFootprint)).call(this, props));

    _this.scrollTo = function (id) {
      return function () {
        var ele = document.getElementById(id);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
      };
    };

    _this.clickViewMoreRelativeCarbonFootprint = function () {
      _this.setState({
        viewMoreRelativeCarbonFootprint: !_this.state.viewMoreRelativeCarbonFootprint
      });
    };

    _this.clickViewMoreRelativeCarbonIntensity = function () {
      _this.setState({
        viewMoreRelativeCarbonIntensity: !_this.state.viewMoreRelativeCarbonIntensity
      });
    };

    _this.clickViewMoreEmissionsScope1_2 = function () {
      _this.setState({
        viewMoreEmissionsScope1_2: !_this.state.viewMoreEmissionsScope1_2
      });
    };

    _this.clickViewMoreEmissionsScope3 = function () {
      _this.setState({
        viewMoreEmissionsScope3: !_this.state.viewMoreEmissionsScope3
      });
    };

    _this.clickViewMoreCoverageDisclosingTitles = function () {
      _this.setState({
        viewMoreCoverageDisclosingTitles: !_this.state.viewMoreCoverageDisclosingTitles
      });
    };

    _this.clickViewMoreCoverageMarketValue = function () {
      _this.setState({
        viewMoreCoverageMarketValue: !_this.state.viewMoreCoverageMarketValue
      });
    };

    _this.renderFootprintTable = function (fund) {
      // each fund has a benchmark comparison calculated by the yoursri API
      var benchmarkExists = fund.benchmarks && fund.benchmarks.length > 0;
      var benchmark = benchmarkExists ? fund.benchmarks[0] : {};

      return _react2.default.createElement(
        'div',
        { styleName: 'foot-table' },
        _react2.default.createElement(
          'div',
          { styleName: 'foot-table-inner' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'foot-table-header' },
            _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 4 }),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-header' },
              fund.fund_legal_name
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-header' },
              'Benchmark: MSCI ACWI',
              _react2.default.createElement(
                'sup',
                null,
                '*'
              )
            )
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            {
              styleName: _this.state.viewMoreEmissionsScope1_2 ? 'foot-table-row-active' : 'foot-table-row',
              onClick: _this.clickViewMoreEmissionsScope1_2,
              title: 'View more' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4 },
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nowrap: true }),
              '\xA0\xA0',
              _this.state.viewMoreEmissionsScope1_2 ? _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-down' }) : _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-right' }),
              _react2.default.createElement(_components.XsBr, null),
              ' ',
              _react2.default.createElement(
                'b',
                null,
                'Emissions scope 1+2'
              ),
              _react2.default.createElement(_components.XsBr, null),
              ' tCO2e'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.number(fund.portfolio_carbon_total_emissions_1_2, true, true)
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.number(benchmark.carbon_total_emissions_1_2, true, true)
            )
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.viewMoreEmissionsScope1_2 ? _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'foot-table-info-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'foot-table-info-row-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'foot-table-info-row-flex-info' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Emissions scope 1+2:'
                    ),
                    ' Measures the absolute greenhouse gas footprint of a portfolio in tons of carbon dioxide equivalents (tCO2e). This measures the total annualized greenhouse gas emissions for which an equity portfolio is responsible, based on the \'ownership principle\'. This is done by summing up the proportionate carbon emissions of companies in the portfolio based on the investor\'s ownership share.'
                  )
                )
              )
            ) : null
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            {
              styleName: _this.state.viewMoreEmissionsScope3 ? 'foot-table-row-active' : 'foot-table-row',
              onClick: _this.clickViewMoreEmissionsScope3,
              title: 'View more' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4 },
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nowrap: true }),
              '\xA0\xA0',
              _this.state.viewMoreEmissionsScope3 ? _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-down' }) : _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-right' }),
              _react2.default.createElement(_components.XsBr, null),
              ' ',
              _react2.default.createElement(
                'b',
                null,
                'Emissions scope 1+2+3'
              ),
              _react2.default.createElement(_components.XsBr, null),
              ' tCO2e'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.number(fund.portfolio_carbon_total_emissions_3, true, true)
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.number(benchmark.carbon_total_emissions_3, true, true)
            )
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.viewMoreEmissionsScope3 ? _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'foot-table-info-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'foot-table-info-row-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'foot-table-info-row-flex-info' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Emissions scope 1+2+3:'
                    ),
                    ' The footprint analysis is based on direct and indirect company emissions (Scope 1 and Scope 2). Scope 3 emissions are only being reported in this specific subsection and on an industry level as currently the definition and the measurement and disclosure is not consistently applied by companies.'
                  )
                )
              )
            ) : null
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            {
              styleName: _this.state.viewMoreCoverageDisclosingTitles ? 'foot-table-row-active' : 'foot-table-row',
              onClick: _this.clickViewMoreCoverageDisclosingTitles,
              title: 'View more' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4 },
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nowrap: true }),
              '\xA0\xA0',
              _this.state.viewMoreCoverageDisclosingTitles ? _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-down' }) : _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-right' }),
              _react2.default.createElement(_components.XsBr, null),
              ' ',
              _react2.default.createElement(
                'b',
                null,
                'Coverage'
              ),
              _react2.default.createElement(_components.XsBr, null),
              ' by # of disclosing titles'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.perc(fund.portfolio_coverage_disclosing_titles / 100)
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.perc(benchmark.coverage_disclosing_titles / 100)
            )
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.viewMoreCoverageDisclosingTitles ? _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'foot-table-info-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'foot-table-info-row-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'foot-table-info-row-flex-info' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Coverage by # of disclosing titles:'
                    ),
                    ' All footprint data is based on South Pole Group\'s database for greenhouse gas emissions of about 40,000 companies. Emissions data is based on disclosed sources, including documents such as company CSR reports, company websites, and non-governmental and regulatory databases, as well as approximations. In cases where the company does not disclose any carbon data or the reported data has been classified as not trustworthy, a carbon estimation methodology is applied. Coverage is measured as a percentage, of both number of disclosing titles and market value weight.'
                  )
                )
              )
            ) : null
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            {
              styleName: _this.state.viewMoreCoverageMarketValue ? 'foot-table-row-active' : 'foot-table-row',
              onClick: _this.clickViewMoreCoverageMarketValue,
              title: 'View more' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4 },
              _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nowrap: true }),
              '\xA0\xA0',
              _this.state.viewMoreCoverageMarketValue ? _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-down' }) : _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-right' }),
              _react2.default.createElement(_components.XsBr, null),
              ' ',
              _react2.default.createElement(
                'b',
                null,
                'Coverage'
              ),
              _react2.default.createElement(_components.XsBr, null),
              ' by market value weight'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.perc(fund.portfolio_coverage_by_weight / 100)
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 4, styleName: 'foot-table-row-number' },
              _format2.default.perc(benchmark.coverage_by_weight / 100)
            )
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _this.state.viewMoreCoverageMarketValue ? _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'foot-table-info-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'foot-table-info-row-flex' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'foot-table-info-row-flex-info' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Coverage by market value weight:'
                    ),
                    ' All footprint data is based on South Pole Group\'s database for greenhouse gas emissions of about 40,000 companies. Emissions data is based on disclosed sources, including documents such as company CSR reports, company websites, and non-governmental and regulatory databases, as well as approximations. In cases where the company does not disclose any carbon data or the reported data has been classified as not trustworthy, a carbon estimation methodology is applied. Coverage is measured as a percentage, of both number of disclosing titles and market value weight.'
                  )
                )
              )
            ) : null
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'foot-table-disclaimer' },
            '* Full emissions and coverage data for MSCI ACWI index provided by yourSRI'
          )
        )
      );
    };

    _this.renderFootprintResults = function (fund) {
      var yoursriIcon = require('../../../static/images/yoursri-logo.png');
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement(_components.BenchmarkChart, { fund: fund }),
        _react2.default.createElement(
          'div',
          { styleName: 'yoursri-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'yoursri-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'yoursri-box' },
              _react2.default.createElement(
                'div',
                { styleName: 'yoursri-info' },
                'Carbon footprint profile is provided by ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.yoursri, title: 'yourSRI.com', xstrong: true },
                  _react2.default.createElement(
                    'b',
                    null,
                    'yourSRI'
                  )
                ),
                '. Metrics like carbon footprint and carbon intensity are calculated by tracking and measuring the greenhouse gas emissions of the underlying companies owned by the fund.',
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.yoursri, title: 'yourSRI.com', xstrong: true },
                  _react2.default.createElement(
                    'b',
                    null,
                    'Find more carbon footprint information about this fund at yourSRI.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'yoursri-icon-wrap' },
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.yoursri, title: 'yourSRI.com' },
                  _react2.default.createElement('img', { styleName: 'yoursri-icon', alt: 'yourSRI.com',
                    src: yoursriIcon })
                )
              )
            )
          )
        ),
        _this.renderFootprintTable(fund),
        _react2.default.createElement(_components.PortfolioContributors, { fund: fund })
      );
    };

    _this.renderSorryNoData = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement(
          'div',
          { styleName: 'sorry-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'sorry-container-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'sorry-headline' },
              'Sorry, we don\'t have a carbon footprint for this fund.'
            )
          )
        )
      );
    };

    _this.state = {
      viewMoreRelativeCarbonFootprint: false,
      viewMoreRelativeCarbonIntensity: false,
      viewMoreEmissionsScope1_2: false,
      viewMoreEmissionsScope3: false,
      viewMoreCoverageDisclosingTitles: false,
      viewMoreCoverageMarketValue: false
    };
    return _this;
  }

  (0, _createClass3.default)(FundCarbonFootprint, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // window.addEventListener('scroll', this.handleScroll)
      _analytics2.default.event(_analytics2.default.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId));
    }

    // handleScroll = () => {
    //   if( !this.props.result ){ return }
    // }

    // need this solution since asyncConnect and anchor links does not play nice

  }, {
    key: 'render',
    value: function render() {
      // loading icons
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      }

      var _props$result = this.props.result,
          fund = _props$result.fund,
          shareClass = _props$result.shareClass;
      // const { holdings, fundholdings } = fund

      var title = shareClass.fund_legal_name + ' | Carbon footprint';
      var url = _config2.default.domain + this.props.location.pathname;

      var _ticker = shareClass.ticker || null;
      var fundName = '' + fund.fund_legal_name;
      fundName = _ticker ? fundName + ' ' + _ticker : fundName;
      var description = fundName + ' has a carbon footprint of ' + _format2.default.number(_convert2.default.float(fund.usd_relative_footprint)) + ' tonnes CO2 / $1M USD invested';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FundMenu, {
          active: 'Carbon footprint',
          fundId: shareClass.fund_id,
          investmentVehicleId: shareClass.investment_vehicle_id,
          name: shareClass.fund_legal_name,
          ticker: shareClass.ticker
        }),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(_components.FootprintDeprecated, null)
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'fossil-fuel-banner-wrap' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h2',
              { styleName: 'fossil-fuel-banner-hl' },
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-lg' },
                'Carbon footprint'
              ),
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-sm' },
                'of all the companies in the portfolio.'
              )
            )
          )
        ),
        fund.usd_relative_footprint && _convert2.default.float(fund.usd_relative_footprint) !== 0.0 ? this.renderFootprintResults(fund) : this.renderSorryNoData(),
        _react2.default.createElement(_components.IyvScorecard, {
          fund: fund,
          shareClass: shareClass
        }),
        _react2.default.createElement(_components.FundShareTakeAction, { shareClass: shareClass, url: url })
      );
    }
  }]);
  return FundCarbonFootprint;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = FundCarbonFootprint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundCarbonFootprint/FundCarbonFootprint.js
// module id = 1401
// module chunks = 0